import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ObservableService } from '../ObservableService/observable.service';
const AUTH_API = environment.apiUrl;

@Injectable({
  providedIn: 'root',
})
export class AnalyzeService {
  _facilityPiComponent: any = {};
  _facilityPiFilterObj: any = {};
  _facilityPiRecord: any = {};
  _currentDate = "";
  _currentTime: any;
  _statusValue: any;
  _reportType = "";
  _facilitySelectedTab = "";
  _spinnerValue:any;

  constructor(private http: HttpClient, private Observable:ObservableService, private location: Location) { }

  currentDateTime() {
    var data;
    var today = new Date();
    this._currentTime = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    today.toLocaleString('it-IT', { month: 'long' });
    data = today.toString();
    data = data.split(' ');
    this._currentDate = data[1].concat(' ').concat(data[2]).concat(',').concat(data[3]);
  }
  CalanderDateRangeSelection(isFacilityRole: boolean): any{
    const today = new Date();
    const minDate = new Date(
      isFacilityRole
        ? today.getFullYear()
        : today.getFullYear() - 1,
      isFacilityRole
        ? today.getMonth() - 6
        : today.getMonth(),
      today.getDate()
    );
  
    return minDate;
  }

  ClearQueryParams() {
    const urlWithoutParams = this.location.path().split('?')[0];
    this.location.replaceState(urlWithoutParams);
  }
  

  GetFacilityPIList(roleName:any,UID:any) {
    return this.http.get(AUTH_API + `/FacilityPI/FacilityPIFiltirsData?roleName=${roleName}&userId=${UID}`)
  }
  GetAllData(obj:any,roleName:any,UID:any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetAllData?roleName=${roleName}&userId=${UID}`,obj)
  }
  getFacilityDashboardValues(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/SpreadSheetReport?roleName=${roleName}&userId=${UID}`, obj)
  }
  getRapidiNotificationValues(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/RAPIDINotification?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetACTIrapidinotification(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/GetACTIrapidinotification?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetASTIrapidinotification(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/GetASTIrapidinotification?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetTHDIrapidinotification(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/GetTHDIrapidinotification?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetTHAIrapidinotification(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/GetTHAIrapidinotification?roleName=${roleName}&userId=${UID}`, obj)
  }
  getTPAAnalysisValues(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/GetTPAAnalysis?roleName=${roleName}&userId=${UID}`, obj)
  }
  getPITrendsValues(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetPITrends?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetRootCauseTrends(roleName: any, UID: any, obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetRootCauseTrends?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetCaseReviewTrends(roleName: any, UID: any, obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetCaseReviewTrends?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetStrokeAlertCases(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetStrokeAlertCases?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetVolumetricsCases(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetVolumeMetrics?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetCounterMeasures(roleName:any,UID:any,obj: any) {
    this.Observable.value$.next(true);
    return this.http.post(AUTH_API + `/FacilityPI/GetCounterMeasure?roleName=${roleName}&userId=${UID}`, obj)
  }
  GetCounterMeasureModal(obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetCounterMeasureModal?cas_key=${obj}`, '');
  }
  GetFacilityDashboardAllChartValues(roleName:any, UID:any, request: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetFacilityDashboardAllCharts?roleName=${roleName}&userId=${UID}`, request);
  }
  GetFacilityDashboardChartValues(roleName:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/FacilityPI/GetFacilityDashboardGraph?roleName=${roleName}&userId=${UID}`, obj
    // , {
      // params: {
      //   status: obj.data.Status
      // }
    // }
    )
  }

  getAllCases(roleNmae:any,UID:any,obj: any) {
    return this.http.post(AUTH_API + `/case/GetAllCases?roleName=${roleNmae}&userId=${UID}`, obj);
  }
  getCaseDetailByCaseId(caseId: any) {
    return this.http.get(AUTH_API + '/case/GetCaseByCaseKey?cas_key=' + caseId);
  }
  saveCaseLeadershipReview(id: any, obj: any) {
    return this.http.post(AUTH_API + `/case/SaveLeaderShip?createdByName=${id}`, obj);
  }
  fetchHistoryTableData(caseId: any) {
    return this.http.get(AUTH_API + '/case/GetCaseHistory?casekey=' + caseId);
  }
  submit
  (case_key: any,formdata: any) {
    return this.http.post(AUTH_API + '/case/SaveCaseReviewData?casekey=' + case_key,formdata);
  }
  LoadCaseReviewTemplate
  (case_key: any) {
    return this.http.get(AUTH_API + '/case/LoadCaseReviewTemplate?casekey=' + case_key);
  }
  SaveReviewTemplate(obj: any) {
    return this.http.post<any>(AUTH_API + `/case/SaveReviewTemplate`, obj);
  }
  DeleteRCARootCause(id: any) {
    return this.http.post(AUTH_API + `/case/DeleteRCARootCause?id=${id}`, '');
  }
  GetFacilityPhysician(facility: any) {
    return this.http.post(AUTH_API + '/case/GetFacilityPhysician', facility);
  }
  GetFacilityBySystem(systemId: any) {
    return this.http.get(AUTH_API + '/facilities/GetFacilityBySystem?systemId=' + systemId);
  }

  SendEmailRCAFacility(obj: any){
    return this.http.post<any>(AUTH_API + '/case/SendEmailRCAFacility', obj);
  }

  GetEmailRcaFacility(facility: any, take: any, skip: any){
    return this.http.post(AUTH_API + `/case/GetEmailRcaFacility?facility=${facility}&Take=${take}&Skip=${skip}`, '');
  }

  GetUserByFacility(model: any){
    return this.http.post(AUTH_API + '/improve/GetUserByFacility', model);
  }
}